var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronCircleForwardLtr = function SvgChevronCircleForwardLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M50 92C26.804 92 8 73.196 8 50S26.804 8 50 8s42 18.804 42 42-18.804 42-42 42m0-78.967c-20.416 0-36.967 16.55-36.967 36.967S29.583 86.967 50 86.967 86.967 70.417 86.967 50 70.416 13.033 50 13.033",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44.788 69.342a2.2 2.2 0 0 1-3.137.002 2.26 2.26 0 0 1-.035-3.138l.032-.033 15.998-16.197-15.964-16.148a2.26 2.26 0 0 1-.031-3.139l.032-.033a2.2 2.2 0 0 1 3.104-.031l.033.032L62.35 48.39a2.26 2.26 0 0 1 .033 3.137l-.032.033z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronCircleForwardLtr;